var _text, _circle, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 55,
    viewBox: "0 0 420 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 55,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 48,
    fill: "#ffffff",
    fontWeight: 600
  }, "\n    Attendix\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 40,
    r: 20,
    fill: "#F8B615"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "252,40 258,46 268,34",
    fill: "none",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLogo);
export default __webpack_public_path__ + "static/media/dashboard_logo.9dd1e1f17f1c6501aa67e00f6babe6b0.svg";
export { ForwardRef as ReactComponent };